import React, { useMemo } from 'react'
import { MoreVertical } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'

const textColorMap = {
  primary: '',
  secondary: 'text-muted-foreground',
  success: 'text-[hsl(var(--success))]',
  danger: 'text-destructive',
  warning: 'text-[hsl(var(--warning))]',
  info: 'text-[hsl(var(--info))]',
}

const RowActions = ({ row, actions }) => {
  const { t } = useTranslation()
  const visibleActions = useMemo(
    () => actions.filter(({ show }) => !show || show(row)),
    [actions, row],
  )

  if (visibleActions.length === 0) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={(e) => e.stopPropagation()}>
          <span className="sr-only">{t('Grid_open_menu', 'Open menu')}</span>
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('Grid_actions', 'Actions')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {visibleActions.map(({ title, color, action, divider }, i) => {
          const titleText = typeof title === 'function' ? title(row) : title
          return (
            <React.Fragment key={i}>
              {divider && i > 0 && <DropdownMenuSeparator />}
              <DropdownMenuItem
                className={color ? (textColorMap[color] || '') : ''}
                onClick={(e) => { e.stopPropagation(); action(row) }}
              >
                {titleText}
              </DropdownMenuItem>
            </React.Fragment>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default RowActions
